module.exports = __webpack_public_path__ + "img/intro-1.8eb07e0f.png";